<template>
  <div>

    <h4 class="titulo-component">Cancelar Inscrição</h4>
    <div class="container-form">

      <el-form @submit.native.prevent="onSubmit" :model="dados" ref="dados" label-position="top">
        <el-row :gutter="10">

          <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="Código de Inscricao" key="cod_inscricao" :rules="[$requiredBlur]" prop="documento">
                <el-input v-model="dados.documento" v-mask="'##########'"></el-input>
              </el-form-item>
          </el-col>
        </el-row>

        <el-alert v-if="erro" :title="erro" :closable="false" type="error" show-icon></el-alert>
        <el-alert v-if="success" :title="success" :closable="false" type="success" show-icon></el-alert>
        
        <div class="container-btns">
          <el-button native-type="submit" type="primary">Cancelar Inscrição</el-button>
        </div>
      
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      erro: '',
      success: '',
      dados: {
        documento: ''
      },
    };
  },
  methods: {
    onSubmit() {

      this.$refs.dados.validate(async (valid) =>{ if(valid){

        this.$confirm('Tem certeza que deseja cancelar a inscrição deste documento? Se confirmado, o aluno será removido do sistema de pré-matrícula.', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(async () => {
          
          let response = await this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/cancelaInscricaoNovatos/${this.dados.documento}`, this.$store.getters.getHeaderAuth);

          if(typeof response.data.erro !== 'undefined'){

            this.success = '';
            this.erro = response.data.erro;
            return;   

          }else if(response?.data?.status == 'success'){    
            
            this.dados.documento = '';
            this.erro = '';
            this.success = response.data.message;
          }  
          
        }).catch(() => { });

      }else{
          window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
      }});

    }
  }
};
</script>
<style>
  .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
      line-height: 0px !important;
  }
</style>